'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _paymentModal = require('./payment-modal');

var _paymentModal2 = _interopRequireDefault(_paymentModal);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_button2['default'], {
    buttonText: 'Continue',
    buttonLink: '#',
    buttonColor: 'cerulean',
    buttonTextColor: 'white'
}, 'agreementContinueButton');

var _ref2 = _jsx('form', {
    id: 'agreementForm',
    method: 'POST',
    action: ''
});

var EnterpriseAgreement = _react2['default'].createClass({
    displayName: 'EnterpriseAgreement',


    propTypes: {
        'fullName': _react2['default'].PropTypes.string, // Full name of the person agreeing
        'email': _react2['default'].PropTypes.string.isRequired, // Their email address
        'companyName': _react2['default'].PropTypes.string, // Their company name
        'billingName': _react2['default'].PropTypes.string, // Optional billing contact name, if different
        'billingEmail': _react2['default'].PropTypes.string, // Optional billing contact email, if different
        'numSeats': _react2['default'].PropTypes.number.isRequired, // Number of seats on the plan
        'totalRate': _react2['default'].PropTypes.string.isRequired, // Total rate (formatted)
        'periodName': _react2['default'].PropTypes.string.isRequired, // Billing period (month or year)
        'features': _react2['default'].PropTypes.array.isRequired, // List of features { name, [code], [value], enabled }
        'paymentForm': _react2['default'].PropTypes.object.isRequired, // Serialized payment form
        'paymentInfo': _react2['default'].PropTypes.object.isRequired, // Payment information { card, subscription, ... }
        'siteCode': _react2['default'].PropTypes.string.isRequired, // Site code
        'isApi': _react2['default'].PropTypes.bool.isRequired, // Whether it's for an API plan
        'termsAccepted': _react2['default'].PropTypes.bool, // If they've already accepted the terms
        'numApiSigRequests': _react2['default'].PropTypes.string, // Number of API signature requests
        'apiCouponInfo': _react2['default'].PropTypes.object // API coupon information { percentage, duration }
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'termsAccepted': false
        };
    },

    launchPaymentModal: function launchPaymentModal(evt) {

        var target = $(evt.target);
        if (!target.hasClass('m-button') && target.parents('.m-button').length === 0) {
            return;
        }

        evt.preventDefault();

        var attachPoint = HfReactHelper.getRevealAttachPoint('payment_modal', this.props.paymentInfo.card ? 'small' : 'medium');
        var d = this.props.paymentInfo;
        var cc = d.card;
        var s = d.subscription;
        var n = this.props.numSeats;

        var cardholder = "";
        if (cc) {
            cardholder = cc.holderName;
        } else if (this.props.billingName && this.props.billingEmail !== this.props.email) {
            cardholder = this.props.billingName;
        }

        _reactDom2['default'].render(_jsx(_paymentModal2['default'], {
            planId: d.planId,
            isFreeTrialEligible: false,
            isTrialing: false,
            numFreeDays: 0,
            price: d.price,
            timePeriod: s.timePeriod,
            monthlyExpectedRate: s.monthlyExpectedRate * n,
            annualExpectedRate: s.annualExpectedRate * n,
            monthlyProratedRate: s.monthlyProratedRate * n,
            annualProratedRate: s.annualProratedRate * n,
            currentMonthlyRate: s.currentMonthlyRate * n,
            currentAnnualRate: s.currentAnnualRate * n,
            proratio: s.proratio,
            couponCode: s.couponCode,
            ccSuffix: cc ? cc.suffix : "",
            ccExpiration: cc ? cc.expiration : "",
            cardHolderName: cardholder,
            name: d.name,
            isApi: d.isApi || false,
            termsAccepted: this.props.termsAccepted,
            paymentForm: this.props.paymentForm,
            numSeats: this.props.numSeats,
            headerText: 'Enterprise Plan'
        }, 'paymentModal_' + d.planId), attachPoint);
    },

    submitForm: function submitForm() {
        $('#agreementForm').submit();
    },

    render: function render() {

        var name, email, company, onBehalfOf;
        var continueButton, ctaSubText;
        var paymentModal;
        var features = [];
        var coupon;
        var hasSeparateBillingContact = this.props.billingEmail && this.props.billingEmail !== this.props.email;

        // Header
        if (this.props.fullName || this.props.billingName) {
            name = _jsx('div', {
                className: 'm-plan-agreement--header--name'
            }, void 0, hasSeparateBillingContact ? this.props.billingName : this.props.fullName);
        }
        if (this.props.companyName) {
            company = _jsx('div', {
                className: 'm-plan-agreement--header--company'
            }, void 0, this.props.companyName);
        }
        if (hasSeparateBillingContact) {
            onBehalfOf = _jsx('div', {
                className: 'm-plan-agreement--header--on-behalf-of'
            }, void 0, 'On behalf of ', this.props.fullName, ' (', this.props.email, ')');
        }

        // Coupon
        if (this.props.apiCouponInfo) {
            coupon = _jsx('span', {
                className: 'm-plan-agreement--summary--coupon'
            }, void 0, this.props.apiCouponInfo.percentage, '% off', this.props.apiCouponInfo.duration > 0 ? " for " + (this.props.apiCouponInfo.duration == 9999 ? "perpetuity" : this.props.apiCouponInfo.duration + " months") : "");
        }

        var totalClassNames = (0, _classnames2['default'])({
            'm-plan-agreement--summary--block': true,
            'total': true,
            'with-subtext': coupon !== undefined
        });

        // Features
        var i = -1;
        var n = this.props.features.length;
        var feature, featureClasses, featureValue, hasValue;
        var hasHipaa = false;
        for (var k in this.props.features) {
            feature = this.props.features[k];
            hasValue = false;
            if (feature.enabled === undefined || feature.enabled === true) {
                if (!hasHipaa && feature.code === HfReactHelper.HfConstants.enterpriseFeatures.HIPAA) {
                    hasHipaa = true;
                }
                hasValue = feature.value !== undefined;
                featureClasses = (0, _classnames2['default'])({
                    'm-plan-agreement--features--table--item': true,
                    'with-value': hasValue,
                    'is-left': ++i % 2 === 0,
                    'is-bottom': n % 2 === 0 && i >= n - 2 || n % 2 === 1 && i === n - 1,
                    'is-top': i < 2
                });
                featureValue = hasValue ? _jsx('div', {
                    className: 'm-plan-agreement--features--table--item--value'
                }, void 0, feature.value === null ? "UNLIMITED" : feature.value) : undefined;
                features.push(_jsx('div', {
                    className: featureClasses
                }, 'feature-' + feature.name, featureValue, _jsx('div', {
                    className: 'm-plan-agreement--features--table--item--name'
                }, void 0, feature.name)));
            }
        }

        // Continue button
        continueButton = _ref;

        // HIPAA warning
        if (hasHipaa) {
            var siteName = HfReactHelper.HfSites.getSiteName(this.props.siteCode);
            ctaSubText = "Upon payment, your account will be configured for HIPAA compliance. " + "It is your responsibility to continue to use " + siteName + " in a HIPAA compliant manner.";
        }

        return _jsx('div', {
            className: 'm-plan-agreement small-12'
        }, void 0, _jsx('div', {
            className: 'm-plan-agreement--header l-margin-b-40'
        }, void 0, _jsx('div', {
            className: 'm-plan-agreement--header--title'
        }, void 0, 'AGREEMENT FOR'), name, _jsx('div', {
            className: 'm-plan-agreement--header--email'
        }, void 0, hasSeparateBillingContact ? this.props.billingEmail : this.props.email), onBehalfOf, company), _jsx('div', {
            className: 'm-plan-agreement--summary l-margin-b-40 small-12'
        }, void 0, _jsx('div', {
            className: 'm-plan-agreement--summary--blocks'
        }, void 0, _jsx('div', {
            className: 'm-plan-agreement--summary--block senders'
        }, void 0, _jsx('p', {
            className: 'm-plan-agreement--summary--text'
        }, void 0, this.props.isApi ? "Signature requests per month" : "Number of senders"), _jsx('div', {
            className: 'm-plan-agreement--summary--number'
        }, void 0, this.props.isApi ? this.props.numApiSigRequests : this.props.numSeats)), _jsx('div', {
            className: totalClassNames
        }, void 0, _jsx('span', {
            className: 'm-plan-agreement--summary--number'
        }, void 0, _jsx('span', {
            className: 'm-plan-agreement--summary--currency'
        }, void 0, '$'), parseInt(this.props.totalRate, 10)), _jsx('span', {
            className: 'm-plan-agreement--summary--text'
        }, void 0, 'per ', this.props.periodName), _jsx('span', {
            className: 'm-plan-agreement--summary--subtext'
        }, void 0, coupon)))), _jsx('div', {
            className: 'm-plan-agreement--features small-12 l-margin-b-40'
        }, void 0, _jsx('div', {
            className: 'm-plan-agreement--features--title'
        }, void 0, 'FEATURES'), _jsx('div', {
            className: 'm-plan-agreement--features--table'
        }, void 0, features)), _jsx('div', {
            className: 'm-plan-agreement--cta small-12'
        }, void 0, _jsx('div', {
            onClick: this.launchPaymentModal
        }, void 0, continueButton), _jsx('div', {
            className: 'm-plan-agreement--cta--text'
        }, void 0, ctaSubText)), _ref2, paymentModal);
    }

});

module.exports = EnterpriseAgreement;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/enterprise-agreement.jsx
 ** module id = 796
 ** module chunks = 0
 **/